import { gql, useMutation } from "@apollo/client";

const DELETE_ASSET = gql`
  mutation DeleteAsset($deleteAssetId: String!) {
    deleteAsset(id: $deleteAssetId)
  }
`;

type AssetApi = {
  deleteAsset(id: string): Promise<void>;
};

export default function useDeleteAsset(): AssetApi {
  const [deleteAssetMut] = useMutation(DELETE_ASSET);

  async function deleteAsset(id: string): Promise<void> {
    if (id.length === 0) {
      return Promise.resolve();
    }

    await deleteAssetMut({
      variables: {
        deleteAssetId: id,
      },
    });
  }

  return {
    deleteAsset,
  };
}
